module.exports = __webpack_public_path__ + "img/arum_colombe_de_la_paix.bd8e38c9.jpg";